import { useEffect, useState } from 'react';
import { get, post } from '../../helpers/api_helper';
import { Row, Col, Card, CardBody, Button, Modal, ModalBody, CardFooter } from "reactstrap"
import {
  DndContext,
  closestCenter,
  MouseSensor,
  TouchSensor,
  KeyboardSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext,
  sortableKeyboardCoordinates,
  rectSortingStrategy,
  useSortable,
  arrayMove,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DropzoneCustomize from '../../components/Dropzone';
import picUpload from '../../assets/images/assets/upload.png';
import ImageGallery from 'react-image-gallery';
import toastr from 'toastr';
import './index.scss';
import { uuid } from '../../utils';

const SortableCarouselPicture = ({ id, picture, removePic }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1 : 'auto',
    touchAction: 'none',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <Card className="card-picture">
        <img className="border" src={picture.picture} width="100%" height="100%" />
        <div className="position-absolute">
          <Button onClick={() => removePic(picture.id)} className="btn-link btn-danger" style={{ background: 'none', border: 'none' }}><i className="text-danger fa fa-trash"></i></Button>
        </div>
      </Card>
    </div>
  );
};

const Carousel = props => {
  const [list, setList] = useState([]);
  const [isOpenUpload, setIsOpenUpload] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  useEffect(() =>{
    get(`/carousels/list`)
      .then((data) => {
        setList(data)
      })
  }, [])
  const save = () => {
    setIsSaving(true)
    post('/carousels/create', {
      list: list.map(picture => ({
        picture: picture.picture
      }))
    })
      .then(() => {
        toastr.success('Lưu carousel thành công')
      })
      .catch((err) => {
        toastr.error(err.error)
      })
      .finally(() => {
        setIsSaving(false)

      })
  }
  const removePic = (id) => {
    setList(list.filter(picture => picture.id !== id))
  }

  const sensors = useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 8 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 150, tolerance: 8 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  );

  const onDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) {
      return;
    }

    const oldIndex = list.findIndex(picture => picture.id === active.id);
    const newIndex = list.findIndex(picture => picture.id === over.id);
    if (oldIndex === -1 || newIndex === -1) {
      return;
    }

    setList(arrayMove(list, oldIndex, newIndex))
  }

  const onUploadSuccess = (url) => {
    const newList = [...list]
    const newPicture = {
      picture: url,
      id: uuid()
    }
    newList.push(newPicture)
    setList(newList)
  }

  return (
    <>
      <div className="page-content page-carousel">
       
          <Breadcrumbs title="Carousel" breadcrumbItem="Danh sách Carousel" />
          <Row>
            <Col md={{ size: 6, offset: 3 }} xs={12}>
              <Card className="list-carousel">
                <CardBody>
                  <div>
                    <ImageGallery
                    
                      items={list.map(picture => ({
                        renderItem: () => <img className="border" src={picture.picture} width="100%" height="100%"/>
                      }))}
                      showPlayButton={false}
                      showFullscreenButton={false}
                    />
                  </div>

                  <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={onDragEnd}
                  >
                    <SortableContext items={list.map(picture => picture.id)} strategy={rectSortingStrategy}>
                      <div className="list-pictures">
                        {list.map((picture) =>
                          <SortableCarouselPicture key={picture.id} id={picture.id} picture={picture} removePic={removePic} />
                        )}
                        <Card className="card-picture" onClick={() => setIsOpenUpload(true)}><img src={picUpload}/></Card>
                      </div>
                    </SortableContext>
                  </DndContext>
                </CardBody>
                <CardFooter align="right">
                  <Button disabled={isSaving} className="btn-success" onClick={save}>Lưu</Button>
                </CardFooter>
              </Card>
              <Modal
                isOpen={isOpenUpload}
                toggle={() => setIsOpenUpload(!isOpenUpload)}
                centered={true}
              >
                {isOpenUpload ? 
                <>
                  <ModalBody style={{ minHeight: 150}} >
                    <DropzoneCustomize 
                      onUploadSuccess={onUploadSuccess}
                      urlUpload={() => '/carousels/upload-picture'}
                    />
                  </ModalBody>
                </>
                : null}
                
              </Modal>
            </Col>
          </Row>
      </div>
    </>
  )
}

export default Carousel
